import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import useWindowPosition from './hooks/useWindowPosition';
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import ButtonToScroll from './components/ButtonToScroll';

function App() {

  const { pathname } = useLocation();
  const [scrollToHostesses, setScrollToHostesses] = useState(false);
  const { positionY } = useWindowPosition();

  const TRACKER_ID = process.env.REACT_APP_GA_TRACKER_ID;

  useEffect(() => {
    if (scrollToHostesses && pathname === "/accueil") {
      window.scrollTo(0, document.getElementById('section-hostesses').getBoundingClientRect().y + window.scrollY - document.getElementById("header").offsetHeight);
    }
    else {
      window.scrollTo(0, 0);
    }
    ReactGA.initialize([
      {
        trackingId: TRACKER_ID,
        gtagOptions: {
          send_page_view: false
        },
      }
    ]);
    ReactGA.send({ hitType: "pageview", page: pathname, title: pathname === "/" ? "Accueil" : pathname.charAt(1).toUpperCase() + pathname.substring(2) });
    // eslint-disable-next-line
  }, [pathname])

  return (
    <HelmetProvider>
      <Header setScrollToHostesses={setScrollToHostesses} />
      <Main scrollToHostesses={scrollToHostesses} setScrollToHostesses={setScrollToHostesses} />
      {positionY > 50 &&
        <ButtonToScroll />
      }
      <Footer setScrollToHostesses={setScrollToHostesses} />
    </HelmetProvider>
  );
}

export default App;
